<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
<!--            <v-card-actions class="py-0">-->
<!--                <v-text-field-->
<!--                        class="ma-0 pa-0"-->
<!--                        label="Test Name"-->
<!--                        outlined-->
<!--                        v-model="aBtest.name"-->
<!--                ></v-text-field>-->
<!--            </v-card-actions>-->
            <v-card-actions class="py-0">
                <v-textarea
                        outlined
                        v-model="infoMessage"
                        label="Message"
                ></v-textarea>
            </v-card-actions>
<!--            <v-card-actions class="ma-0 pa-0 mb-3">-->
<!--                <v-card-text class="grey&#45;&#45;text ma-0 pa-0 ml-4">Audiences</v-card-text>-->
<!--                <v-spacer></v-spacer>-->
<!--                <v-btn color="green" class="mr-0" icon @click="addAudience()"><v-icon>mdi-plus</v-icon></v-btn>-->
<!--                <v-btn color="red" class="mr-4" icon @click="removeAudience()"><v-icon>mdi-minus</v-icon></v-btn>-->
<!--            </v-card-actions>-->
<!--            <v-card-actions class="py-0 mb-10">-->
<!--                <v-card width="100%" elevation="0" style="display:flex">-->
<!--                    <v-card-actions style="width: 100%" class="ma-0 pa-0">-->
<!--                        <SplitGrid-->
<!--                                @drag="onDrag"-->
<!--                                :style="{'margin-right': (aBtest.audiences.length - 1) * 5 + 'px'}"-->
<!--                                :strictMode="false"-->
<!--                                class="sb_sub-grid"-->
<!--                                v-bind="splitGridOptions">-->
<!--                            <template v-for="(audience, index) in audiences">-->
<!--                                <SplitGridArea-->
<!--                                        size-unit="%"-->
<!--                                        :size-value="audience.percent"-->
<!--                                        :key="audience.name">-->
<!--                                    <v-card elevation="0" :color="audience.getColor()">-->
<!--                                        <v-card-actions>-->
<!--                                            <h4 style="color: white;" class="ma-0 pa-0">{{ audience.name.toUpperCase() }}</h4>-->
<!--                                            <h4 style="color: white;" class="ma-0 pa-0">({{ Math.round(audience.percent) }})%</h4>-->
<!--                                            <v-spacer></v-spacer>-->
<!--                                        </v-card-actions>-->
<!--                                    </v-card>-->
<!--                                </SplitGridArea>-->
<!--                                <SplitGridGutter-->
<!--                                        :key="audience.name + 's'"-->
<!--                                        v-show="index != aBtest.audiences.length - 1"-->
<!--                                        style="background-color: grey; margin: 1px"/>-->
<!--                            </template>-->
<!--                        </SplitGrid>-->
<!--                    </v-card-actions>-->
<!--                </v-card>-->
<!--            </v-card-actions>-->
<!--            <v-card-actions class="py-0">-->
<!--                <v-text-field label="Users (0 - all)" type="number" v-model="aBtest.users" outlined dense :rules="[rules.value]"></v-text-field>-->
<!--            </v-card-actions>-->
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="ma-2"
                       color="primary"
                       @click="onPressSave">SAVE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: "configs-popup-edit-info",
    props: {},
    components: {},
    data: () => ({
        dialog: false,
        infoMessage: "",
        config:null,
        onComplete:null,
    }),
    computed: {
    },
    methods: {
        show(config, onComplete) {
            this.dialog = true
            this.infoMessage = config.info
            this.config = config
            this.onComplete = onComplete
        },
        hide() {
            this.dialog = false
        },
        onClose() {
            this.hide()
        },
        onPressSave() {
            this.dialog = false
            this.onComplete(this.config, this.getMessage())
            //this.$emit('complete-edit-config-info', this.config, this.getMessage())
            // this.buttonLoading = true
            // if (this.type == "my"){
            //     ConfigStoreUtils.updateConfig(config)
            //         .then(() => {
            //             this.$notify({title: 'Info successfully changed!', text: "", type: "succes"});
            //             this.dialog = false
            //             this.buttonLoading = false
            //         }).catch((error) => {
            //         this.$notify({title: 'Info change failed!', text: error, type: "error"});
            //         this.dialog = false
            //         this.buttonLoading = false
            //     })
            // }else if (this.type == "pre"){
            //     ConfigStoreUtils.updateReleaseConfig(config, null)
            //         .then(() => {
            //             this.$notify({title: 'Info successfully changed!', text: "", type: "succes"});
            //             this.dialog = false
            //             this.buttonLoading = false
            //         }).catch((error) => {
            //         this.$notify({title: 'Info change failed!', text: error, type: "error"});
            //         this.dialog = false
            //         this.buttonLoading = false
            //     })
            // }else{
            //
            // }
        },
        getMessage(){
            return this.infoMessage
        },
    },
}
</script>

<style scoped>
</style>
